import { Component, Input, OnInit,ChangeDetectorRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { timeZoneService } from 'src/app/services/timezone.service';
import { RestService } from 'src/app/services/rest-service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppSettings } from 'src/app/shared/app-settings';
import { SdtService } from 'src/app/services/sdt.service';
import { Title } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-monitors',
  templateUrl: './monitors.component.html',
  styleUrls: ['./monitors.component.scss'],
  standalone: false
})
export class MonitorsComponent implements OnInit {
  @Input() deviceInfoDataObj:any;
  @Input() cameraMeta:any;
  @Input() cameraMetadata:any;
  @Input() mdcMetadata:any;
  @Input() routerInfo:any;

  displayStyle:string = 'none';
  public allMonitorsData: Array<any> = [];
  public filteredMonitorsData: Array<any> = [];
  p: number = 0;
  total: number;
  size: number;
  ipP: number;
  currentPage: number = 1;
  booleanValue: any = false;
  totalPages: number;
  siteFilter: any = '';
  searchFilter: any = '';
  deviceType: any;
  subType: any;
  currentuser: any;
  username: string;
  readOnlyUser: boolean = false;
  sorted: boolean = false;
  loading: boolean = true;
  csvPath;
  options: string;
  selectedPotentialId = 0;
  selectedPotentialIdPM = 0;
  selectedDevice: any[];
  selectedDevicePM: any[];
  readOnlySdt: boolean;
  deviceIndex: any;
  selectedMonitrsData: any[];
  selectedMonitrsData1: any[];
  forPotentialId: boolean = false;
  forPotentialIdPM: boolean = false;
  urlexport: any;
  type = 'all';
  searchResult = false;
  devices: any;
  mainType: any = [];
  subTypes: any = [];
  loadingUserMessage: string = 'Loading ...';
  manageSdt: boolean = false;
  viewPlannedMaintenance: boolean = false;
  isPageError: boolean=true;
  pageLoadMessage: string = "Loading ...";
  healthData: any;
  uqId: string;
  sitesData: any;
  Response: any;
  sdtDevices: any;
  isAnyCheckboxChecked: boolean = false;
  isPmMainCheckboxChecked: boolean = false;
  isAnyPMchecked: boolean = false;
  isCreateSdtButtonVisible = true;
  selectedDeviceIds: string[] = [];
  columnVisibility: any = {};
  dropdownVisible = false;
  checkedCount:number = 0;
  pmCount:number = 0;
  selectedDeviceIdsPM: any;
  selectedMonitors = new Set<any>();
  isAnyCheckboxCheckedPM: boolean;
  allPMdata: any;
  PMids:Array<any>=[];
  pmLength: any;
  pmId: any;
  pmData: any;
  devicesData: any[];
  cachedData: any;
  selectAll: boolean;
  showPM:boolean = true;
  showSDT:boolean = true;
  siteTimeZone: any;
  allDown: boolean = false;
  downCount = 0;
  allMonitorsDataLength: number;
  upUnique = [];
  pmUnique = [];
  upLen:number = 0;
  pmLen:number = 0;

  constructor(
    private titleService: Title,
    public spinner: SpinnerService,
    private toastr: ToastrService,
    public authService: AuthenticationService,
    public timeZoneService: timeZoneService,
    public restService: RestService,
    private router: Router,
    private sdtService: SdtService,
    private route: ActivatedRoute,
    private http: HttpClient,
    private cdr: ChangeDetectorRef
  ) {
    this.titleService.setTitle("Devices");
    // this.csvPath = AppSettings.API_ENDPOINT + AppSettings.DEVICE_CSV;
    this.deviceType = 'all';
    this.subType = 'all';
    this.urlexport = `monitors/devices/export?search&status&deviceType`;
    this.csvPath = AppSettings.API_ENDPOINT + '/' + this.urlexport;
  }

  ngOnInit(): void {
    try {
      this.searchFilter = this.route.snapshot.paramMap.get('id');
    } catch (e) {}

    this.spinner.activate();
    this.loading = true;

    this.getCurrentuser();
    this.getMonitors();
    this.getSdt();
    this.getSubdropdown();
    this.getX310();
    this.loadColumnVisibility();
    this.selectAll = this.areAllColumnsSelected();
    this.cachedData = localStorage.getItem('pmData');
    if (localStorage.getItem('selectAllState-devices') !== JSON.stringify(this.selectAll)) {
      localStorage.setItem('selectAllState-devices', JSON.stringify(this.selectAll));
    }
    let title = this.titleService.getTitle();
  }

  getCurrentuser() {
    this.loadingUserMessage = 'Loading ...';
    this.currentuser = this.authService.currentUserValue;
    if (this.currentuser) {
      this.username = this.currentuser.firstName;
      if (
        this.currentuser['privileges'] &&
        this.currentuser['privileges'].length > 0
      ) {
        for (let i = 0; i < this.currentuser['privileges'].length; i++) {
          if (
            this.currentuser['privileges'][i].toLowerCase() === 'manage sdt'
          ) {
            this.manageSdt = true;
          }
          if (
            this.currentuser['privileges'][i].toLowerCase() === 'view planned maintenance'
          ) {
            this.viewPlannedMaintenance = true;
          }
        }
      }
    }
  }

  loadColumnVisibility() {
    const savedColumnVisibility = localStorage.getItem('devicesColumnVisibility');
    if (savedColumnVisibility) {
      this.columnVisibility = JSON.parse(savedColumnVisibility);
    } else {
      this.columnVisibility = {
        'Device Type': true,
        'Camera Owned': true,
        'Device IP': true,
        'Port': true,
        'Interval': true,
        'Status': true,
        'Message': true,
        'Status Duration': true,
        'Time Stamp': true,
        'SDT': true,
        'PM': true
      };
    }

    const restrictedColumns = ['Potential ID','Site Name','Site Unit ID','Device Name','Type'];
    restrictedColumns.forEach(column => {
    this.columnVisibility[column] = true;
  });
  }

  toggleColumn(columnName: string) {
    this.columnVisibility[columnName] = !this.columnVisibility[columnName];
    this.saveColumnVisibility();  
  }

  toggleDropdown() {
    this.dropdownVisible = !this.dropdownVisible;
  }

  getColumnVisibilityKeys() {
    return Object.keys(this.columnVisibility);
  }

  isColumnRestricted(column: string): boolean {
    const restrictedColumns = ['Potential ID','Site Name','Site Unit ID','Device Name','Type'];
    return restrictedColumns.includes(column);
  }

  updateColumnVisibility(selectedColumns: string[]) {
    for (const column in this.columnVisibility) {
      if (this.columnVisibility.hasOwnProperty(column)) {
        this.columnVisibility[column] = false;
      }
    }

    selectedColumns.forEach(column => {
      this.columnVisibility[column] = true;
    });

    this.dropdownVisible = false;
    this.saveColumnVisibility();  
  }

  areAllColumnsSelected(): boolean {
    const allSelected = Object.keys(this.columnVisibility).every((column) => {
      return this.columnVisibility[column] || this.isColumnRestricted(column);
    });
    
    return allSelected;
  }


  onColumnVisibilityChange(column: string) {
    this.selectAll = this.areAllColumnsSelected();
    localStorage.setItem('selectAllState-devices', JSON.stringify(this.selectAll))
    this.saveColumnVisibility();
    this.selectAll = Object.keys(this.columnVisibility).every(column => {
      return this.columnVisibility[column] || this.isColumnRestricted(column);
    });
  }

  saveColumnVisibility() {
    localStorage.setItem('devicesColumnVisibility', JSON.stringify(this.columnVisibility));
    this.selectAll = this.areAllColumnsSelected();
  }

  toggleAllColumns(selectAll: boolean): void {
    Object.keys(this.columnVisibility).forEach(column => {
      if (!this.isColumnRestricted(column)) {
        this.columnVisibility[column] = selectAll;
      }
    });
    this.saveColumnVisibility();
    localStorage.setItem('selectAllState-devices', JSON.stringify(this.selectAll));
  }

  loadSelectAllState(): void {
    const savedSelectAllState = localStorage.getItem('selectAllState-devices');
    if (savedSelectAllState !== null) {
      this.selectAll = JSON.parse(savedSelectAllState);
    } else {
      this.selectAll = this.areAllColumnsVisible();
    }
  }
  
  areAllColumnsVisible(): boolean {
    return Object.values(this.columnVisibility).every(visibility => visibility);
  }
  
  saveSelectAllState() {
    localStorage.setItem('selectAllState-devices', JSON.stringify(this.selectAll));
  }

  getSdt() {
    this.loadingUserMessage = 'Loading ...';
    let url = AppSettings.SDTGET;
    let devicesNames = [];
    this.restService.getRequest(url, '').subscribe(
      (response) => {
        if (response.hasOwnProperty('data') && response.data !== null) {
          this.sdtDevices = response.data;
          this.sdtService.DBdata = this.sdtDevices;
          for (var i = 0; i < this.sdtDevices.length; i++) {
            let devicesName = this.sdtDevices[i].deviceUniqueId;
            devicesNames.push(devicesName);
            this.selectedDevice = devicesNames;
          }
          this.Response = response;
        } else {
          this.sdtService.DBdata = [];
        }
      },
      (err) => {
        if (
          err &&
          err.error &&
          err.error.message &&
          err.error.message.length > 0
        ) {
          this.toastr.error(err.error.message, 'Error');
        } else {
          this.toastr.error('Session Expired Please login again.', 'Error');
        }
      }
    );
  }

  getMonitors() {
    this.loadingUserMessage = 'Loading ...';
    this.spinner.activate();
    this.loading = true;
    if (!localStorage.getItem('deviceDrpdwnObj')) {
      this.getSubdropdown();
    } else {
      this.bindDropdowns();
    }
    this.restService.getRequest(AppSettings.DASHBOARDMONITORS, '').subscribe(
      (response) => {
        if(response ==null || response?.data == null || response?.data?.content == null){
          this.isPageError=true;
          this.loadingUserMessage = 'No data found';
        } else {
          this.isPageError=false;
          this.pageLoadMessage="";
        }
          if (response?.data?.content?.length == 0) {
            this.loadingUserMessage = 'No data found';
          }

        if (
          response?.hasOwnProperty('data') &&
          response?.data !== null &&
          response?.data !== undefined &&
          response?.data?.content?.length > 0
        ) {
          this.allMonitorsData = response?.data?.content;
          this.filteredMonitorsData = response?.data?.content;
          this.total = response?.data?.totalElements;
          this.size = response?.data?.numberOfElements;
          this.p = response?.data?.number + 1;
          this.ipP = response?.data?.size;
          this.totalPages = response?.data?.totalPages;
          this.spinner.deactivate();
          this.loading = false;
          if (
            this.searchFilter != '' &&
            this.searchFilter != null &&
            this.searchFilter != undefined
          ) {
            this.deviceTypeChange();
          }
        } else {
          this.spinner.deactivate();
          this.loading = false;
          if(response?.data?.content?.length == 0){
          this.loadingUserMessage = 'No data found';
          this.toastr.error('Devices Data not found');
          }
        }
      },
      (err) => {
        this.spinner.deactivate();
        this.loading = false;
        this.loadingUserMessage = 'No data found';
        if (
          err &&
          err.error &&
          err.error.message &&
          err.error.message.length > 0
        ) {
          this.toastr.error(err.error.message, 'Error');
        } else {
          this.toastr.error('Session Expired Please login again.', 'Error');
        }
      }
    );
    if(this.cachedData){
      this.allPMdata = JSON.parse(this.cachedData);
    } else {
      this.getAllPM();
    }
  }

  getSubdropdown() {
    this.restService.getRequest(AppSettings.SUBDROPDOWN, '').subscribe((dt) => {
      this.devices = dt;
      localStorage.setItem('deviceDrpdwnObj', JSON.stringify(dt));
      this.bindDropdowns();
    });
  }

  bindDropdowns() {
    this.mainType = [];
    this.devices = JSON.parse(localStorage.getItem('deviceDrpdwnObj'));
    for (let i = 0; i < this.devices.length; i++) {
      this.mainType.push(this.devices[i].deviceType);
    }
  }

  pmFlags(){
    this.pmCount = 0;
    this.showSDT = true;
    this.showPM = true;
    this.isPmMainCheckboxChecked = false;
  }

  statusChange() {
    this.pmFlags();
    this.selectedPotentialId = 0;
    this.getData();
    this.selectedMonitors.clear();
    this.updateCreateSdtButtonVisibility();  
  }

  updateCreateSdtButtonVisibility() {
      if (!this.isCheckboxOnCurrentPage()) {
        this.hideCreateSdtButton();
      }
    }

  hideCreateSdtButton() {
    const createSdtButton = document.getElementById('createSdtButton');
      if (createSdtButton) {
        createSdtButton.style.display = 'none';
      }
    }
    
  isCheckboxOnCurrentPage() {
    const checkboxIdsOnCurrentPage = this.filteredMonitorsData.map(data => 'checkbox' + data.deviceUqId);
    return this.selectedDeviceIds.some(deviceId => checkboxIdsOnCurrentPage.includes('checkbox' + deviceId));
  }
    

  navigateDetails(sdtDevice) {
    this.router.navigate(['/sdt-details', { device: sdtDevice }]);
  }

  navigateDetailsPM(pmUqId,pmPotential,pmUnitId,pmTimeZone) {
    this.router.navigate(['/planned-maintenance-details'], { 
      state: { pmUqId, pmPotential, pmUnitId, pmTimeZone }
    });
  }

  changeValue(change: Event, selectedData): void {
    this.loadingUserMessage = 'Loading ...';
    const element = change.target as HTMLInputElement;
    const deviceId = selectedData.deviceUqId;
    this.options = (<HTMLInputElement>change.target).value;
    let isChecked = (<HTMLInputElement>change.target).checked;
    this.currentPage = this.p;

    if (element.checked) {
        // At least one checkbox is checked
        this.checkedCount++;
        if(this.checkedCount >0 ){
          this.showPM = false;
        }
        this.isAnyCheckboxChecked = true;
        this.selectedDeviceIds.push(deviceId);
      } else {
        // Check if any checkbox is still checked
        this.checkedCount--;
        this.isAnyCheckboxChecked = this.filteredMonitorsData.some(data => {
        const checkboxId = 'checkbox' + data.deviceUqId;
        const checkboxElement = document.getElementById(checkboxId) as HTMLInputElement;
        return checkboxElement && checkboxElement.checked;
      });
        const index = this.selectedDeviceIds.indexOf(deviceId);
        if (index !== -1) {
          this.selectedDeviceIds.splice(index, 1);
          }
    }

    if (!isChecked) {
      let element = document.getElementById('sdt-cb') as HTMLInputElement;
      if (element) {
        element.checked = false;
      }
    }
    this.selectedPotentialId = selectedData.potentialId;
    this.sdtService.selectedDevice = selectedData;
    let checkAllSelected = false;

    for (let index = 0; index < this.filteredMonitorsData.length; index++) {
      this.deviceIndex = this.filteredMonitorsData[index];
      this.type = this.filteredMonitorsData[index].type;
      let id = 'checkbox' + index;
      const element = document.getElementById(id) as HTMLInputElement;
      if (element) {
        if (element.checked == true) {
          this.selectedPotentialId =
            this.filteredMonitorsData[index].potentialId;
          this.disableOtherPotentialIds();
          //checkAllSelected=true;
          this.showPM = false;
          break;
        } else {
          this.selectedPotentialId = 0;
          checkAllSelected = false;
          this.showPM = true;
        }
      }
    }
    if (isChecked) {
      let falseCheckList = 0;
      let trueCheckList = 0;
      let docList = 0;
      let filterMonitersDatalength = this.filteredMonitorsData.length;
      for (let index = 0; index < filterMonitersDatalength; index++) {
        let id = 'checkbox' + index;
        const element = document.getElementById(id) as HTMLInputElement;
        if (element) {
          if(element.disabled==true){
            falseCheckList = falseCheckList + 1;
          }
            if (element.checked == true) {
            trueCheckList = trueCheckList +1;
            }
            if(trueCheckList == (filterMonitersDatalength - (falseCheckList + docList))){
                checkAllSelected=true;
                this.isCreateSdtButtonVisible = true;
          } else {
            checkAllSelected = false;
          }
          } else if(element == null){
            docList = docList + 1;
          }
      }
      if (checkAllSelected) {
        let element = document.getElementById('sdt-cb') as HTMLInputElement;
        if (element) {
          element.checked = true;
          this.isCreateSdtButtonVisible = true;
        }
      }
    }
    if (this.selectedPotentialId == 0) {
      this.enableOtherPotentialIds();
    }
    const isCheckboxCheckedOnCurrentPage = this.checkedCount > 0 && this.currentPage === this.p;
    const isCheckboxEnabled = selectedData.zenTicketId !== null && selectedData.status !== 'Up' && this.manageSdt;
    this.isCreateSdtButtonVisible = this.filteredMonitorsData.length > 0 && this.checkedCount > 0;

    if (!isCheckboxCheckedOnCurrentPage || !isCheckboxEnabled) {
      this.isCreateSdtButtonVisible = false;
    }  
  }

  changeValue1(event: Event, monitordata: any) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.siteTimeZone = monitordata.timeZone;
    localStorage.setItem('timeZone',this.siteTimeZone)
    monitordata.pmSelected = isChecked;
    if (isChecked) {
        this.selectedPotentialIdPM = monitordata.potentialId;
        this.pmCount++;
        if(this.pmCount > 0 || this.isPmMainCheckboxChecked == true){
          this.showSDT = false;
        }
        this.selectedMonitors.add(monitordata);
    } else {
        this.pmCount--;
        if (!this.filteredMonitorsData.some(md =>
                md.potentialId === monitordata.potentialId && md.pmSelected && md.deviceUqId !== monitordata.deviceUqId)) {
            this.filteredMonitorsData.forEach(md => {
                if (md.potentialId === monitordata.potentialId && md.status !== 'Down') {
                    md.isDisabled = false;
                }
            });
            this.selectedPotentialIdPM = 0;
            if(this.pmCount == 0){
              this.showSDT = true;
            }
        }
        this.selectedMonitors.delete(monitordata);
    }
    this.filteredMonitorsData.forEach(md => {
        md.isDisabled = this.isPMcheckboxDisabled(md);
    });
    this.cdr.detectChanges();
}
  isPMcheckboxDisabled(monitordata: any): boolean {
    const isStatusDown = monitordata.status === 'Down';
    const isManagePMNotAllowed = !this.viewPlannedMaintenance;
    const isSelectedPotentialIdNotAllowed = this.selectedPotentialIdPM !== 0 && this.selectedPotentialIdPM !== monitordata.potentialId;
    return isStatusDown || isManagePMNotAllowed || isSelectedPotentialIdNotAllowed;
  }
  showPMdetails(monitordata: any): boolean {
      const isInPMData = this.pmData?.includes(monitordata?.deviceUqId);
      const canManagePM = this.viewPlannedMaintenance;
      const isPMColumnVisible = this.columnVisibility['PM'];
      const isShowPM = this.showPM;
      
      return isInPMData && isPMColumnVisible && isShowPM;
  }
  showSDTdetails(monitordata: any): boolean {
    const isDeviceSelected = this.selectedDevice?.includes(monitordata?.deviceUqId);
    const isSDTColumnVisible = this.columnVisibility['SDT'] && this.showSDT;
    
    return isDeviceSelected && isSDTColumnVisible;
  }
  createPM() {
    this.selectedMonitrsData1 = [];
    Array.from(this.selectedMonitors).forEach((monitor) => {
      this.selectedMonitrsData1.push({
        accId: monitor.accId,
        potentialId: monitor.potentialId,
        siteUnitId: monitor.siteUnitId,
        siteName: monitor.siteName,
        siteType: monitor.siteType,
        deviceUniqueId: monitor.deviceUqId,
        deviceName: monitor.deviceName,
        deviceType: monitor.deviceType,
        type: monitor.type,
        pdStartDate: '',
        pdEndDate: '',
        pdReason: '',
        pdSubReason: '',
        createdAt: '',
        updatedAt: '',
        createdBy: '',
        updatedBy: '',
      });
    });
    this.sdtService.selectedDevicePM = this.selectedMonitrsData1;
  }

  getAllPM(){
    this.spinner.activate();
    let url = AppSettings.GET_ALL_PM;
    this.restService.getRequest(url,'').subscribe((response)=>{
    if(response && response.data && response.data.content){
      this.allPMdata = response?.data?.content;
      localStorage.setItem('pmData', JSON.stringify(this.allPMdata));
      this.sdtService.pmDBdata = this.allPMdata;
      for(let i=0; i<this.allPMdata.length; i++){
        this.pmId = this.allPMdata[i]?.deviceUqId;
        this.PMids.push(this.pmId);
        this.pmData = this.PMids;
        this.cdr.detectChanges();
        this.spinner.deactivate();
      }
     } else {
      this.sdtService.pmDBdata = [];
      this.spinner.deactivate();
     }
    })
  }

  disableOtherPotentialIds() {
    for (let index = 0; index < this.filteredMonitorsData.length; index++) {
      let id = 'checkbox' + index;
      const element = document.getElementById(id) as HTMLInputElement;
      if (element) {
        if (
          this.filteredMonitorsData[index].potentialId ==
          this.selectedPotentialId
        ) {
          if (
            this.filteredMonitorsData[index].zenTicketId != null &&
            this.filteredMonitorsData[index].status != 'Up'
          ) {
            element.disabled = false;
          }
        } else {
          element.disabled = true;
        }
      }
    }
  }
  enableOtherPotentialIds() {
    for (let index = 0; index < this.filteredMonitorsData.length; index++) {
      let id = 'checkbox' + index;
      const element = document.getElementById(id) as HTMLInputElement;
      if (element) {
        if (
          this.filteredMonitorsData[index].zenTicketId != null &&
          this.filteredMonitorsData[index].status != 'Up'
        ) {
          element.disabled = false;
        }
      }
    }
  }

  createSdt() {
    this.selectedMonitrsData = [];
   if (this.filteredMonitorsData && this.filteredMonitorsData.length > 0 && this.filteredMonitorsData !== undefined && this.filteredMonitorsData !== null) {
    for (let index = 0; index < this.filteredMonitorsData.length; index++) {
      let id = 'checkbox' + index;
      const element = document.getElementById(id) as HTMLInputElement;
      if (element) {
        if (element.checked == true) {
          this.selectedMonitrsData.push({
            accId: this.filteredMonitorsData[index].accId,
            deviceName: this.filteredMonitorsData[index].deviceName,
            deviceType: this.filteredMonitorsData[index].deviceType,
            type: this.filteredMonitorsData[index].type,
            deviceUniqueId: this.filteredMonitorsData[index].deviceUqId,
            siteName: this.filteredMonitorsData[index].siteName,
            siteUnitId: this.filteredMonitorsData[index].siteUnitId,
            siteType: this.filteredMonitorsData[index].siteType,
            sdtStartDate: '',
            sdtEndDate: '',
            sdtReason: '',
            createdBy: '',
            createdAt: '',
            updatedBy: '',
            updatedAt: '',
            sdtStatus: 'Open',
          });
        }
      }
    }
   }
    var deviceName = this.selectedMonitrsData[0].deviceName
    this.sdtService.selectedDevices = this.selectedMonitrsData;
  }

  /**
   * getNewItems
   */
  public getNewItems(p) {
    this.loadingUserMessage = 'Loading ...';
    this.allMonitorsData = [];
    this.filteredMonitorsData = [];
    let page = p - 1;
    let url = `monitors/devices/all?search=${this.searchFilter == null ? '' : this.searchFilter}&status=${this.siteFilter}&deviceType=${this.deviceType == 'all' ? '' : this.deviceType}&type=${this.subType == 'all' ? '' : this.subType}&page=${page}&sort=`;
    if (url) {
      this.filterData(url);
    }
    this.selectedDeviceIds = [];
  }

  deviceTypeChange() {
    this.loadingUserMessage = 'Loading ...';
    if (this.deviceType != 'all') {
      let selectedDeviceData = this.devices.find((ele) => ele.deviceType == this.deviceType);
      this.subTypes = selectedDeviceData.deviceSubTypes;
      this.subType = 'all';
    }
    this.pmFlags();
    this.getData();
    this.changeCheckboxStatus(false);
    this.selectedMonitors.clear();
    this.selectedPotentialId = 0;
    this.selectedPotentialIdPM = 0;
    this.forPotentialId = false;
    this.forPotentialIdPM = false;
    this.searchResult = false;
    this.updateCreateSdtButtonVisibility();
  }

  searchChange() {
    this.upUnique = [];
    this.pmUnique = [];
    this.selectedMonitors.clear();
    this.selectedPotentialId =0;
    this.selectedPotentialIdPM = 0;
    this.pmCount = 0;
    this.isPmMainCheckboxChecked = false;
    this.showPM = true;
    this.showSDT = true;
    this.getData();
  }

  subdeviceTypeChange() {
    this.pmFlags();
    this.getData();
    this.selectedPotentialId = 0;
    this.selectedMonitors.clear();
    this.updateCreateSdtButtonVisibility();
  }

  getData() {
    this.loadingUserMessage = 'Loading ...';
    if (!this.deviceType && !this.searchFilter && !this.siteFilter) {
      this.getMonitors();
      this.forPotentialId = false;
      this.forPotentialIdPM = false;
      this.selectedPotentialId = 0;
      this.selectedPotentialIdPM = 0;
      return;
    }
    this.allMonitorsData = [];
    this.filteredMonitorsData = [];
    let deviceType;
    if (
      this.searchFilter != null &&
      this.searchFilter != undefined &&
      this.searchFilter != ''
    ) {
      this.searchResult = true;
    }
    let type2;
    let url;
    if (this.deviceType == 'all') {
      deviceType = '';
    } else {
      deviceType = this.deviceType;
    }
    if (this.subType == 'all') {
      this.subType = '';
    } else {
      this.subType = this.subType;
    }
    url = `monitors/devices/all?search=${this.searchFilter == null ? '' : this.searchFilter}&status=${this.siteFilter}&deviceType=${deviceType == 'all' ? '' : deviceType}&type=${this.subType}&page=&sort=`;
    this.urlexport = `monitors/devices/export?search=${this.searchFilter}&status=${this.siteFilter}&deviceType=${deviceType == 'all' ? '' : deviceType}&type=${this.subType}`;

    if (this.urlexport) {
      this.filterData(url);
      this.csvPath = AppSettings.API_ENDPOINT + '/' + this.urlexport;
    } else {
      this.toastr.error('Data not found');
    }
    this.forPotentialId = true;
    this.forPotentialIdPM = true;
    this.loading = false;
  }
  allDisabled() {
    let checkboxStatus = true;
    for (let index = 0; index < this.filteredMonitorsData.length; index++) {
      let checkboxId = 'checkbox' + index;
      let element = document.getElementById(checkboxId) as HTMLInputElement;
      if (element) {
        if (!element.disabled) {
          checkboxStatus = false;
        }
      }
    }
    return checkboxStatus;
  }

  checkUniquePotentialIds() {
    let initId = this.filteredMonitorsData[0].potentialId;
    // let findUniquePotentialId = this.filteredMonitorsData.filter(ele => ele.potentialId != initId)
    for (let index = 0; index < this.filteredMonitorsData.length; index++) {
      if (this.filteredMonitorsData[index].potentialId != initId) {
        return true;
      }
    }
    return false;
  }

  changeFiltervalue(evt) {
    this.loadingUserMessage = 'Loading ...';
    if (evt.target.checked) {
      this.showPM = false;
      if (this.filteredMonitorsData) {
        if (!this.checkUniquePotentialIds()) {
          for (let i = 0; i < this.filteredMonitorsData.length; i++) {
            if (this.filteredMonitorsData[i].zenTicketId !== null) {
              this.changeCheckboxStatus(true);
              this.selectedPotentialId = this.searchFilter;
            }
          }
        }
      }
    } else {
      this.showPM = true;
      this.changeCheckboxStatus(false);
      this.selectedPotentialId = 0;
    }
  }
  changeCheckboxStatus(activity) {
    for (let index = 0; index < this.filteredMonitorsData.length; index++) {
      let checkboxId = 'checkbox' + index;
      let element = document.getElementById(checkboxId) as HTMLInputElement;
      if (element && !element.disabled) {
        element.checked = activity;
      }
    }
  }

  sortItems(colName, boolean) {
    this.pmCount = 0;
    this.upUnique = [];
    this.pmUnique = [];
    this.selectedMonitors.clear();
    if (this.p || this.p === 0) {
      let sortOrder = this.sorted == true ? 'ASC' : 'DESC';
      this.sorted = this.sorted == false ? true : false;
      this.allMonitorsData = [];
      this.filteredMonitorsData = [];
      let page = this.p - 1;
      let url = `monitors/devices/all?search=${this.searchFilter == null ? '' : this.searchFilter}&status=${this.siteFilter}&deviceType=${this.deviceType == 'all' ? '' : this.deviceType}&type=${this.subType == 'all' ? '' : this.subType}&page=${page}&sort=${colName},${sortOrder}`;
      if (url) {
        this.filterData(url);
      }
    }
    const selectedDevicesInCurrentPage = this.filteredMonitorsData.filter(data => this.selectedDeviceIds.includes(data.deviceUqId));
    const isAnySelectedDeviceInCurrentPage = selectedDevicesInCurrentPage.length > 0;
    this.isAnyCheckboxChecked = isAnySelectedDeviceInCurrentPage;
  }

  private filterData(url: string, callback = () => {}) {
    this.loadingUserMessage = 'Loading ...';
    this.spinner.activate();
    this.loading = true;
    this.restService.getMonitorsByFilter(url).subscribe(
      (response) => {
        if (response.hasOwnProperty('data') && response.data !== null) {
          this.allMonitorsData = response.data.content;
          let pmIds = JSON.parse(localStorage.getItem('pmData'))?.map(pm => pm.deviceUqId);
          for(let i=0; i<=this.allMonitorsData.length; i++){
            if(this.allMonitorsData[i]?.status == 'Up'){
              this.upUnique.push(this.allMonitorsData[i].deviceUqId)
            }
        }
        this.upLen = this.upUnique.length;
        this.allMonitorsData.forEach((monitorData) => {
          if (pmIds && pmIds.includes(monitorData.deviceUqId)) {
            this.pmUnique.push(monitorData.deviceUqId);
          }
        });
        this.pmLen = this.pmUnique.length;

          this.loading = false;
          this.filteredMonitorsData = response?.data?.content;
          if (this.filteredMonitorsData.length == 0) {
            this.loadingUserMessage = 'No data found';
          } else {
            this.loadingUserMessage = '';
          }
          this.size = response.data.numberOfElements;
          this.total = response.data.totalElements;
          this.p = response.data.number + 1;
          this.spinner.deactivate();
          this.loading = false;
          callback();
        } else {
          this.loading = true;
          this.spinner.deactivate();
          this.loadingUserMessage = 'No data found';
          this.toastr.error('Data not found');
        }
      },
      (err) => {
        this.loadingUserMessage = 'No data found';
        this.spinner.deactivate();
        this.loading = false;
        if (
          err &&
          err.error &&
          err.error.message &&
          err.error.message.length > 0
        ) {
          this.toastr.error(err.error.message, 'Error');
        } else {
        }
      }
    );
  }

  upCountFlag(){
    return this.upLen > this.pmLen;
  }

  /**
   * filterAlldata
   */
  public filterAlldata() {
    this.loadingUserMessage = 'Loading ...';
    this.spinner.activate();
    this.loading = true;
    this.allMonitorsData = [];
    this.filteredMonitorsData = [];
    let url = `monitors/devices/byStatus?status=${this.siteFilter}&deviceType=${this.mainType}&siteName=${this.searchFilter}&page=${this.p - 1}`;
    this.restService.getMonitorsByFilter(url).subscribe(
      (response) => {
        if (
          response.hasOwnProperty('data') &&
          response.data.hasOwnProperty('content') &&
          response.data.content !== null
        ) {
          this.allMonitorsData = response.data.content;
          this.filteredMonitorsData = response.data.content;
          if (this.filteredMonitorsData.length == 0) {
            this.loadingUserMessage = 'No data found';
          }
          this.size = response.data.numberOfElements;
          this.total = response.data.totalElements;
          this.p = response.data.number + 1;
          this.spinner.deactivate();
          this.loading = false;
        } else {
          this.loading = true;
          this.spinner.deactivate();
          this.toastr.error('Data not found');
        }
      },
      (err) => {
        if (
          err &&
          err.error &&
          err.error.message &&
          err.error.message.length > 0
        ) {
          this.toastr.error(err.error.message, 'Error');
        } else {
          this.toastr.error('Session Expired Please login again.', 'Error');
        }
      }
    );
  }

  getX310(){
    this.restService.getRequest(AppSettings.X3HEALTHMONITORING,'').subscribe((response)=>{
      this.healthData = response.data;
    })
  }

  showdeviceData=(data)=>{
    let filterHealthData = {};
    filterHealthData = this.healthData?.filter(x=>x.siteName === data.siteName)
    if(filterHealthData){
    this.deviceInfoDataObj = filterHealthData[0]; 
    this.displayStyle = "block";
    }
  }
  closePopup = () =>{
    this.displayStyle = "none";
  }

  showCameraData(data:any){
      var clonedObj:any ={};
      let url = AppSettings.API_ENDPOINT + '/' + AppSettings.CAM_INFO_UNIQUE + data;
      this.http.get(url).subscribe(dt=>{
      this.cameraMetadata = dt;
      for (const key in this.cameraMetadata) {
        if (Object.hasOwnProperty.call(this.cameraMetadata, key)) {
          const newKey = key.replace(/\./g, '_');
          clonedObj[newKey] = this.cameraMetadata[key];
        }
      }
      this.cameraMeta = clonedObj.data;
      let ele = document.getElementById('myModal2') as HTMLElement;
      if(ele){
        ele.style.display = 'block';
      }
    })
  }

  closeCameraPopup(){
    let ele = document.getElementById('myModal2') as HTMLElement;
      if(ele){
        ele.style.display = 'none';
      }
  }

  showMdcdata(data){
    this.spinner.activate()
    this.restService.getRequest(AppSettings.MDC_DEVICES,'').subscribe((dt)=>{
      this.spinner.deactivate()
      this.mdcMetadata = dt.filter(x=> x.deviceUqId == data.deviceUqId);
      this.mdcMetadata = this.mdcMetadata[0];
      let ele = document.getElementById('myModal3') as HTMLElement;
      if(ele){
        ele.style.display = 'block';
      }
    })
  }

  showRouterdata(data){
    let siteIP = this.filteredMonitorsData?.filter(x=>x.vpnIp === data.vpnIp)[0].vpnIp;
    this.spinner.activate();
    let url = `${AppSettings.ROUTER_INFO}${siteIP}`
    this.restService.getRequest(url,'').subscribe((response)=>{
      this.spinner.deactivate();
      this.routerInfo = response;
      let ele = document.getElementById('myModal4') as HTMLElement;
      if(ele){
        ele.style.display = 'block';
      }
    })
  }

  closeMdcdata(){
    let ele = document.getElementById('myModal3') as HTMLElement;
    if(ele){
      ele.style.display = 'none';
    }
  }

  closeRouterInfo(){
    let ele = document.getElementById('myModal4') as HTMLElement;
    if(ele){
      ele.style.display = 'none';
    }
  }

  selectAllPM(event: any) {
    this.isPmMainCheckboxChecked = event.target.checked;
    this.siteTimeZone = this.allMonitorsData[0]?.timeZone
    this.sdtService.siteTimezone = this.siteTimeZone
    if(this.isPmMainCheckboxChecked){
      this.showSDT = false;
      this.allMonitorsDataLength = this.allMonitorsData.filter(data => data.status !== 'Down').length;
      this.pmCount = this.allMonitorsDataLength;
    } else if(!this.isPmMainCheckboxChecked){
      this.showSDT = true;
      this.pmCount = 0;
    }
    let pmIds = JSON.parse(localStorage.getItem('pmData'))?.map(pm => pm.deviceUqId) || [];
    this.filteredMonitorsData.forEach((data) => {
      if (data.status === 'Up' && !pmIds.includes(data.deviceUqId)) {
        data.pmSelected = this.isPmMainCheckboxChecked;
        if (this.isPmMainCheckboxChecked) {
          this.selectedMonitors.add(data);
        } else {
          this.selectedMonitors.delete(data);
        }
      }
    });
  
    this.selectedPotentialId = this.isPmMainCheckboxChecked ? this.filteredMonitorsData[0]?.potentialId : 0;
  }
  areAllPMSelected(): boolean {
    const upStatusItems = this.filteredMonitorsData.filter(data => data.status === 'Up' && !this.showPMdetails(data));
    return upStatusItems.every(data => data.pmSelected) && upStatusItems.some(data => data.pmSelected);
  }
  
  isPMCheckboxDisabled(monitordata: any): boolean {
    return monitordata.status === 'Down' || (this.selectedPotentialId !== 0 && this.selectedPotentialId !== monitordata.potentialId);
  }
  
  sendData(id: any) {
    this.timeZoneService.updateData(id);
  }

}
